<template>
  <div>
    <div class="md-layout md-layout-item md-size-100">
      <h6 style="margin-top: 25px">Patient information</h6>
    </div>

    <!-- ROW: firstName / lastName -->
    <div class="md-layout" style="min-width: 41rem">
      <!-- FIRSTNAME -->
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field :class="[
          { 'md-valid': !errors.has('firstName') && touched.firstName },
          { 'md-form-group': true },
          { 'md-error': errors.has('firstName') }
        ]">
          <md-icon>person_outline</md-icon>
          <label>First Name</label>
          <md-input v-validate="modelValidations.firstName" v-model="firstName" style="width: inherit" type="text"
            name="firstName" />
          <!-- data-vv-name="firstName" -->
          <slide-y-down-transition>
            <md-icon v-show="errors.has('firstName')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('firstName') && touched.firstName" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- LASTNAME -->
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field :class="[
          { 'md-valid': !errors.has('lastName') && touched.lastName },
          { 'md-form-group': true },
          { 'md-error': errors.has('lastName') }
        ]">
          <md-icon>person</md-icon>
          <label>Last Name</label>
          <md-input v-validate="modelValidations.lastName" v-model="lastName" style="width: inherit"
            data-vv-name="lastName" type="text" name="lastName" />

          <slide-y-down-transition>
            <md-icon v-show="errors.has('lastName')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('lastName') && touched.lastName" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>

    <!-- ROW: email / DOB -->
    <div class="md-layout">
      <!-- EMAIL -->
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field :class="[
          { 'md-valid': !errors.has('email') && touched.email },
          { 'md-form-group': true },
          { 'md-error': errors.has('email') }
        ]" style="margin-top: 25px">
          <md-icon>mail_outline</md-icon>
          <label>Email</label>
          <md-input v-validate="modelValidations.email" v-model="email" style="width: inherit" data-vv-name="email"
            type="email" name="email" />

          <slide-y-down-transition>
            <md-icon v-show="errors.has('email')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('email') && touched.email" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- DOB -->
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field id="dob-field-pt-reg" :class="[
          { 'md-valid': !errors.has('DOB') && touched.DOB },
          { 'md-form-group': true },
          { 'md-error': errors.has('DOB') },
          { 'md-has-value': true }
        ]" style="margin-top: 1.6rem">
          <md-icon>today</md-icon>
          <label for="DOB">Date Of Birth</label>
          <md-input style="border-bottom: solid 1px lightgray !important" v-validate="modelValidations.DOB" id="DOB"
            v-model="DOB" placeholder=" " data-vv-name="DOB" name="DOB" type="date" @pick="updateDOB" />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('DOB')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>

    <!-- ROW: gender / height -->
    <div class="md-layout">
      <!-- GENDER -->
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field :class="[
          { 'md-valid': !errors.has('gender') && touched.gender },
          { 'md-form-group': true },
          { 'md-error': errors.has('gender') }
        ]">
          <md-icon style="margin-right: 0; padding-right: 10px">man_4</md-icon>
          <div style="margin-left: 15px">
            <md-radio v-model="gender" value="Male" style="padding-right: 30px"><span
                style="margin-top: -9px; position: absolute; font-size: 14px">Male</span></md-radio>
            <md-radio v-model="gender" value="Female"><span
                style="margin-top: -9px; position: absolute; font-size: 14px">Female</span></md-radio>
          </div>

          <slide-y-down-transition>
            <md-icon v-show="errors.has('gender')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('gender') && touched.gender" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- HEIGHT -->
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field :class="[
          { 'md-valid': !errors.has('height') && touched.height },
          { 'md-form-group': true },
          { 'md-error': errors.has('height') },
          { 'md-has-value': !!height }
        ]" style="margin-top: 25px; width: inherit">
          <md-icon style="margin-right: 12px; padding-right: 10px">height</md-icon>
          <label>Height</label>
          <select v-validate="'required'" v-model="height" name="height" style="margin-left: 12px; width: inherit">
            <option value="4'9">4' 9"</option>
            <option value="4'10">4' 10"</option>
            <option value="4'11">4' 11"</option>
            <option value="5'0">5' 0"</option>
            <option value="5'1">5' 1"</option>
            <option value="5'2">5' 2"</option>
            <option value="5'3">5' 3"</option>
            <option value="5'4">5' 4"</option>
            <option value="5'5">5' 5"</option>
            <option value="5'6">5' 6"</option>
            <option value="5'7">5' 7"</option>
            <option value="5'8">5' 8"</option>
            <option value="5'9">5' 9"</option>
            <option value="5'10">5' 10"</option>
            <option value="5'11">5' 11"</option>
            <option value="6'0">6' 0"</option>
            <option value="6'1">6' 1"</option>
            <option value="6'2">6' 2"</option>
            <option value="6'3">6' 3"</option>
            <option value="6'4">6' 4"</option>
            <option value="6'5">6' 5"</option>
          </select>
          <slide-y-down-transition>
            <md-icon v-show="errors.has('height')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <!-- <slide-y-down-transition>
            <md-icon v-show="!errors.has('height') && touched.height" class="success">done</md-icon>
          </slide-y-down-transition> -->
        </md-field>
      </div>
    </div>

    <!-- ROW: cellPhone / allowSMS -->
    <div class="md-layout">
      <!-- CELLPHONE -->
      <div class="md-layout-item md-size-50 md-small-size-100">
        <!--style="margin-top: 30px"-->
        <md-field :class="[
          { 'md-valid': !errors.has('cellPhone') && touched.cellPhone },
          { 'md-form-group': true },
          { 'md-error': errors.has('cellPhone') }
        ]" style="margin-top: 25px">
          <md-icon>smartphone</md-icon>
          <label>Cell Phone</label>
          <md-input v-mask="'(999) 999 - 9999'" v-validate="modelValidations.cellPhone" v-model="cellPhone"
            data-vv-name="cellPhone" type="tel" name="cellPhone" style="font-size: xx-large" />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('cellPhone')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('cellPhone') && touched.cellPhone" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- ALLOW SMS -->
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field :class="[
          { 'md-valid': !errors.has('allowSMS') && touched.allowSMS },
          { 'md-form-group': true },
          { 'md-error': errors.has('allowSMS') }
        ]">
          <md-icon style="padding-top: 20px">message</md-icon>
          <div>
            <div class="md-layout">
              <div class="md-layout-item md-size-100" style="display: flex; align-items: center; gap: 8px;">
                <md-switch v-model="allowSMS" class="sms-switch">
                </md-switch>
                <span class="sms-label">Allow SMS</span>
                <span class="tooltip-container" @mouseenter="showTooltip" @mouseleave="hideTooltipWithDelay">
                  <i class="material-icons info-icon">info</i>
                  <div class="tooltip-content" v-if="tooltipVisible" ref="tooltip">
                    <ul>
                      <li>Messaging frequency may vary.</li>
                      <li>Message and data rates may apply.</li>
                      <li>You can opt out any time by texting STOP.</li>
                      <li>
                        For assistance, text HELP or visit our website at
                        <a href="https://www.globechek.com" target="_blank"><b>globechek.com</b></a>.
                      </li>
                      <li>
                        Visit <a href="https://globechek.com/tos.html#privacy" target="_blank"><b>Privacy Policy</b></a>
                        and
                        <a href="https://globechek.com/tos.html#tos" target="_blank"><b>Terms of Service</b></a>.
                      </li>
                    </ul>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </md-field>
      </div>
    </div>

    <!-- <hr
      align="center"
      style="text-align: center; width: 80%; border-color: #9999; margin-top: 35px; margin-bottom: 30px;"
    /> -->
    <!-- border-color: #1565c0;  -->

    <div class="md-layout md-layout-item md-size-100">
      <h6 style="margin-top: 25px">Address</h6>
    </div>

    <!-- ROW: Address-L1 / Address-L2 -->
    <div class="md-layout">
      <!-- ADDRESS-L1 -->
      <div class="md-layout-item md-size-50">
        <md-field :class="[
          { 'md-valid': !errors.has('address_L1') && touched.address_L1 },
          { 'md-form-group': true },
          { 'md-error': errors.has('address_L1') }
        ]">
          <md-icon>location_on</md-icon>
          <label>Address Line 1</label>
          <md-input v-validate="modelValidations.address_L1" v-model="address_L1" style="width: inherit"
            data-vv-name="address_L1" type="text" name="address_L1" />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('address_L1')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('address_L1') && touched.address_L1" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- ADDRESS-L2 -->
      <div class="md-layout-item md-size-50">
        <md-field :class="[
          { 'md-valid': !errors.has('address_L2') && touched.address_L2 },
          { 'md-form-group': true },
          { 'md-error': errors.has('address_L2') }
        ]">
          <md-icon>location_on</md-icon>
          <label>Address Line 2</label>
          <md-input v-validate="modelValidations.address_L2" v-model="address_L2" style="width: inherit"
            data-vv-name="address_L2" type="text" name="address_L2" />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('address_L2')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('address_L2') && touched.address_L2" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>

    <!-- ROWL  City / State / Zip -->
    <div class="md-layout">
      <!-- CITY -->
      <div class="md-layout-item md-size-50">
        <md-field :class="[
          { 'md-valid': !errors.has('city') && touched.city },
          { 'md-form-group': true },
          { 'md-error': errors.has('city') }
        ]">
          <md-icon>location_city</md-icon>
          <label>City</label>
          <md-input v-validate="modelValidations.city" v-model="city" style="width: inherit" data-vv-name="city"
            type="text" name="city" />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('city')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('city') && touched.city" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <!-- STATE -->
      <div class="md-layout-item md-size-25">
        <md-field :class="[
          { 'md-valid': !errors.has('State') && touched.state },
          { 'md-form-group': true },
          { 'md-error': errors.has('State') },
          { 'md-has-value': !!state }
        ]">
          <md-icon>outlined_flag</md-icon>
          <label class="spaced-phone-label">State</label>

          <!-- <md-autocomplete @md-changed="filterStates" @md-selected="onSelectState" name="state" data-vv-name="state" v-model="selectedState" :md-options="states"> 
            <label>State</label>
            <template slot="md-autocomplete-item" slot-scope="{ item }">
              {{ item.DisplayValue }}
            </template>
</md-autocomplete>
<p v-if="selectedState">Selected: {{ selectedState.DisplayValue }} (ID: {{ selectedState.LookupId }})</p> -->

          <select v-validate="'required'" id="state-select" ref="stateInput" v-model="state"
            style="margin-left: 12px; width: inherit" data-vv-name="State" type="text" name="State" md-dense>
            <!-- <option value="" disabled selected>State</option> -->
            <option v-for="(state, index) in states" :key="state.LookupId" :id="state.LookupId + '-state'"
              :value="state.LookupId">
              {{ state.DisplayValue }}
            </option>
          </select>
          <slide-y-down-transition>
            <md-icon v-show="errors.has('State')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <!-- <slide-y-down-transition>
            <md-icon v-show="!errors.has('State') && touched.state" class="success">done</md-icon>
          </slide-y-down-transition> -->
        </md-field>
      </div>

      <!-- ZIPCODE -->
      <div class="md-layout-item md-size-25">
        <md-field :class="[
          { 'md-valid': !errors.has('zip') && touched.zip },
          { 'md-form-group': false },
          { 'md-error': errors.has('zip') }
        ]">
          <!--<md-icon>location_on</md-icon>-->
          <label class="spaced-phone-label">Zip-Code</label>
          <md-input v-validate="modelValidations.zip" ref="zipCodeInput" v-model="zip" style="width: inherit"
            data-vv-name="zip" type="text" name="zip" />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('zip')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('zip') && touched.zip" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>

    <!-- ROW: Country /  -->
    <div class="md-layout">
      <!-- COUNTRY -->
      <div class="md-layout-item md-size-50">
        <md-field v-if="countrySwitch" :class="[
          { 'md-valid': touched.country },
          { 'md-form-group': true },
          { 'md-error': errors.has('country') },
          { 'md-has-value': !!country }
        ]" @click.native="countryClearFilter" @keydown.native="countryFind($event)">
          <md-icon>outlined_flag</md-icon>
          <label>Country</label>
          <select v-validate="'required'" id="country-select" ref="countryInput" v-model="country"
            style="margin-left: 12px; width: inherit" type="text" name="country" md-dense>
            <option v-for="(country, index) in countries" :key="country.LookupId" :value="country.LookupId"
              :id="country.LookupId">
              {{ country.DisplayValue }}
            </option>
          </select>
          <slide-y-down-transition>
            <md-icon v-show="errors.has('country')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <!-- <slide-y-down-transition>
            <md-icon v-show="!errors.has('country') && touched.country" class="success">done</md-icon>
          </slide-y-down-transition> -->
        </md-field>
      </div>
    </div>

    <!-- INSURED INFORMATION -->

    <div class="md-layout md-layout-item md-size-100">
      <h6 style="margin-top: 25px">Insured information</h6>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-size-50">
        <md-field :class="[
          { 'md-valid': !errors.has('insuranceId') && touched.insuranceId },
          { 'md-form-group': false },
          { 'md-error': errors.has('insuranceId') }
        ]">
          <md-icon>badge</md-icon>
          <label>Insurance ID</label>
          <md-input v-model="insuranceId"
            v-validate="!currentOrg || !currentOrg.enableClearingHouseIntegration ? '' : 'required'"
            style="width: inherit" data-vv-name="insuranceId" type="text" name="insuranceId" />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('insuranceId')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('insuranceId') && touched.insuranceId" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field :class="[
          { 'md-valid': !errors.has('referralNumber') && touched.referralNumber },
          { 'md-form-group': false },
          { 'md-error': errors.has('referralNumber') }
        ]">
          <md-icon>pin</md-icon>
          <label>Referral Number</label>
          <md-input v-model="referralNumber" style="width: inherit" data-vv-name="referralNumber" type="text"
            name="referralNumber" />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('referralNumber')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('referralNumber') && touched.referralNumber" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field :class="[
          { 'md-valid': !errors.has('insurance') && touched.insurance },
          { 'md-form-group': false },
          { 'md-error': errors.has('insurance') }
        ]">
          <md-icon>assured_workload</md-icon>
          <label>Insurance Company</label>
          <md-input v-model="insurance"
            v-validate="!currentOrg || !currentOrg.enableClearingHouseIntegration ? '' : 'required'"
            style="width: inherit" data-vv-name="insurance" type="text" name="insurance" />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('insurance')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('insurance') && touched.insurance" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>

      <div class="md-layout-item md-size-50 md-small-size-100">
        <md-field :class="[
          { 'md-valid': !errors.has('groupNumber') && touched.groupNumber },
          { 'md-form-group': false },
          { 'md-error': errors.has('groupNumber') }
        ]">
          <label>Group Number</label>
          <md-input v-model="groupNumber"
            v-validate="!currentOrg || !currentOrg.enableClearingHouseIntegration ? '' : 'required'"
            style="width: inherit" data-vv-name="groupNumber" type="text" name="groupNumber" />
          <slide-y-down-transition>
            <md-icon v-show="errors.has('groupNumber')" style="padding: 0" class="alert">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon v-show="!errors.has('groupNumber') && touched.groupNumber" class="success">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </div>
    </div>

    <div class="md-layout-item md-size-100" style="margin-top: 2rem;">
      <md-field :class="[
        { 'md-form-group': true },
        { 'md-valid': !errors.has('patientRelationshipToInsured') && touched.patientRelationshipToInsured },
        { 'md-error': errors.has('patientRelationshipToInsured') },
        { 'md-has-value': !!patientRelationshipToInsured }
      ]">
        <md-icon>assignment_ind</md-icon>
        <label class="spaced-phone-label">Patient relationship to insured</label>
        <select style="margin-left: 12px; width: inherit" v-validate="'required'" v-model="patientRelationshipToInsured"
          data-vv-name="patientRelationshipToInsured" name="patientRelationshipToInsured" md-dense>
          <option :key="'Self'" :value="'Self'">Self</option>
          <option :key="'Spouse'" :value="'Spouse'">Spouse</option>
          <option :key="'Child'" :value="'Child'">Child</option>
          <option :key="'Life Partner'" :value="'Life Partner'">Life Partner</option>
          <option :key="'Employee'" :value="'Employee'">Employee</option>
          <option :key="'Organ Donor'" :value="'Organ Donor'">Organ Donor</option>
          <option :key="'Cadaver Donor'" :value="'Cadaver Donor'">Cadaver Donor</option>
          <option :key="'Other'" :value="'Other'">Other</option>
          <option :key="'Unknown'" :value="'Unknown'">Unknown</option>
        </select>
      </md-field>
    </div>

    <div v-if="patientRelationshipToInsured !== 'Self'">
      <!-- ROW: insuredFirstName / insuredLastName -->
      <div class="md-layout" style="min-width: 41rem;">
        <!-- INSUREDFIRSTNAME -->
        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-field :class="[
            { 'md-valid': !errors.has('insuredFirstName') && touched.insuredFirstName },
            { 'md-form-group': true },
            { 'md-error': errors.has('insuredFirstName') }
          ]">
            <md-icon>person_outline</md-icon>
            <label>Insured First Name</label>
            <md-input v-validate="patientRelationshipToInsured !== 'Self' ? 'required' : ''" v-model="insuredFirstName"
              style="width: inherit" type="text" name="insuredFirstName" />
            <slide-y-down-transition>
              <md-icon v-show="errors.has('insuredFirstName')" style="padding: 0" class="alert">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon v-show="!errors.has('insuredFirstName') && touched.insuredFirstName"
                class="success">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </div>

        <!-- INSUREDLASTNAME -->
        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-field :class="[
            { 'md-valid': !errors.has('insuredLastName') && touched.insuredLastName },
            { 'md-form-group': true },
            { 'md-error': errors.has('insuredLastName') }
          ]">
            <md-icon>person</md-icon>
            <label>Insured Last Name</label>
            <md-input v-validate="patientRelationshipToInsured !== 'Self' ? 'required' : ''" v-model="insuredLastName"
              style="width: inherit" data-vv-name="insuredLastName" type="text" name="insuredLastName" />

            <slide-y-down-transition>
              <md-icon v-show="errors.has('insuredLastName')" style="padding: 0" class="alert">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon v-show="!errors.has('insuredLastName') && touched.insuredLastName" class="success">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </div>
      </div>

      <!-- ROW: GENDER / DOB -->
      <div class="md-layout">

        <!-- GENDER -->
        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-field :class="[
            { 'md-valid': !errors.has('insuredGender') && touched.insuredGender },
            { 'md-form-group': true },
            { 'md-error': errors.has('insuredGender') }
          ]">
            <md-icon style="margin-right: 0; padding-right: 10px">man_4</md-icon>
            <div style="margin-left: 15px; width: inherit">
              <md-radio data-vv-name="insuredGender" name="insuredGender"
                v-validate="patientRelationshipToInsured !== 'Self' ? 'required' : ''" v-model="insuredGender"
                value="Male" style="padding-right: 30px"><span
                  style="margin-top: -9px; position: absolute; font-size: 14px">Male</span></md-radio>
              <md-radio data-vv-name="insuredGender" name="insuredGender"
                v-validate="patientRelationshipToInsured !== 'Self' ? 'required' : ''" v-model="insuredGender"
                value="Female"><span
                  style="margin-top: -9px; position: absolute; font-size: 14px">Female</span></md-radio>
            </div>

            <slide-y-down-transition>
              <md-icon v-show="errors.has('insuredGender')" style="padding: 0" class="alert">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon v-show="!errors.has('insuredGender') && touched.insuredGender" class="success">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </div>

        <!-- DOB -->

        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-field id="dob-field-pt-reg-2" :class="[
            { 'md-valid': !errors.has('insuredDOB') && touched.insuredDOB },
            { 'md-form-group': true },
            { 'md-error': errors.has('insuredDOB') },
            { 'md-has-value': true }
          ]" style="margin-top: 1.6rem">
            <md-icon>today</md-icon>
            <label for="DOB2">Date Of Birth</label>
            <md-input style="border-bottom: solid 1px lightgray !important"
              v-validate="patientRelationshipToInsured !== 'Self' ? 'required' : ''" id="DOB2" v-model="insuredDOB"
              placeholder=" " data-vv-name="insuredDOB" name="insuredDOB" type="date" @pick="updateDOB" />
            <slide-y-down-transition>
              <md-icon v-show="errors.has('insuredDOB')" style="padding: 0" class="alert">close</md-icon>
            </slide-y-down-transition>
          </md-field>
        </div>
      </div>

      <div class="md-layout md-layout-item md-size-100">
        <h6 style="margin-top: 25px">Insured Address</h6>
      </div>

      <!-- ROW: insuredAddress -->
      <div class="md-layout">
        <!-- insuredAddress -->
        <div class="md-layout-item md-size-100">
          <md-field :class="[
            { 'md-valid': !errors.has('insuredAddress') && touched.insuredAddress },
            { 'md-form-group': true },
            { 'md-error': errors.has('insuredAddress') }
          ]">
            <md-icon>location_on</md-icon>
            <label>Address</label>
            <md-input v-validate="patientRelationshipToInsured !== 'Self' ? 'required' : ''" v-model="insuredAddress"
              style="width: inherit" data-vv-name="insuredAddress" type="text" name="insuredAddress" />
            <slide-y-down-transition>
              <md-icon v-show="errors.has('insuredAddress')" style="padding: 0" class="alert">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon v-show="!errors.has('insuredAddress') && touched.insuredAddress" class="success">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </div>
      </div>

      <!-- ROWL  City / State / Zip -->
      <div class="md-layout">
        <!-- CITY -->
        <div class="md-layout-item md-size-50">
          <md-field :class="[
            { 'md-valid': !errors.has('insuredCity') && touched.insuredCity },
            { 'md-form-group': true },
            { 'md-error': errors.has('insuredCity') }
          ]">
            <md-icon>location_city</md-icon>
            <label>City</label>
            <md-input v-validate="patientRelationshipToInsured !== 'Self' ? 'required' : ''" v-model="insuredCity"
              style="width: inherit" data-vv-name="insuredCity" type="text" name="insuredCity" />
            <slide-y-down-transition>
              <md-icon v-show="errors.has('insuredCity')" style="padding: 0" class="alert">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon v-show="!errors.has('insuredCity') && touched.insuredCity" class="success">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </div>

        <!-- STATE -->
        <div class="md-layout-item md-size-25">
          <md-field :class="[
            { 'md-valid': !errors.has('insuredState') && touched.insuredState },
            { 'md-form-group': true },
            { 'md-error': errors.has('insuredState') },
            { 'md-has-value': !!insuredState }
          ]">
            <md-icon>outlined_flag</md-icon>
            <label class="spaced-phone-label">State</label>

            <!-- <md-autocomplete @md-changed="filterStates" @md-selected="onSelectState" name="state" data-vv-name="state" v-model="selectedState" :md-options="states"> 
            <label>State</label>
            <template slot="md-autocomplete-item" slot-scope="{ item }">
              {{ item.DisplayValue }}
            </template>
          </md-autocomplete>
          <p v-if="selectedState">Selected: {{ selectedState.DisplayValue }} (ID: {{ selectedState.LookupId }})</p> -->

            <select v-validate="patientRelationshipToInsured !== 'Self' ? 'required' : ''" id="state-select"
              ref="stateInput" v-model="insuredState" style="margin-left: 12px; width: inherit"
              data-vv-name="insuredState" type="text" name="insuredState" md-dense>
              <!-- <option value="" disabled selected>State</option> -->
              <option v-for="(state, index) in states" :key="state.LookupId" :id="state.LookupId + '-state'"
                :value="state.LookupId">
                {{ state.DisplayValue }}
              </option>
            </select>
            <slide-y-down-transition>
              <md-icon v-show="errors.has('insuredState')" style="padding: 0" class="alert">close</md-icon>
            </slide-y-down-transition>
            <!-- <slide-y-down-transition>
            <md-icon v-show="!errors.has('State') && touched.state" class="success">done</md-icon>
          </slide-y-down-transition> -->
          </md-field>
        </div>

        <!-- ZIPCODE -->
        <div class="md-layout-item md-size-25">
          <md-field :class="[
            { 'md-valid': !errors.has('insuredZip') && touched.insuredZip },
            { 'md-form-group': false },
            { 'md-error': errors.has('insuredZip') }
          ]">
            <!--<md-icon>location_on</md-icon>-->
            <label class="spaced-phone-label">Zip-Code</label>
            <md-input v-validate="patientRelationshipToInsured !== 'Self' ? 'required' : ''" ref="zipCodeInput"
              v-model="insuredZip" style="width: inherit" data-vv-name="insuredZip" type="text" name="insuredZip" />
            <slide-y-down-transition>
              <md-icon v-show="errors.has('insuredZip')" style="padding: 0" class="alert">close</md-icon>
            </slide-y-down-transition>
            <slide-y-down-transition>
              <md-icon v-show="!errors.has('insuredZip') && touched.zip" class="success">done</md-icon>
            </slide-y-down-transition>
          </md-field>
        </div>
      </div>

      <!-- ROW: Country /  -->
      <div class="md-layout">
        <!-- COUNTRY -->
        <div class="md-layout-item md-size-50">
          <md-field v-if="countrySwitch" :class="[
            { 'md-valid': touched.insuredCountry },
            { 'md-form-group': true },
            { 'md-error': errors.has('insuredCountry') },
            { 'md-has-value': !!insuredCountry }
          ]" @click.native="countryClearFilter" @keydown.native="countryFind($event)">
            <md-icon>outlined_flag</md-icon>
            <label>Country</label>
            <select v-validate="patientRelationshipToInsured !== 'Self' ? 'required' : ''" id="country-select2"
              ref="countryInput" v-model="insuredCountry" style="margin-left: 12px; width: inherit" type="text"
              name="insuredCountry" md-dense>
              <option v-for="(country, index) in countries" :key="country.LookupId" :value="country.LookupId"
                :id="country.LookupId">
                {{ country.DisplayValue }}
              </option>
            </select>
            <slide-y-down-transition>
              <md-icon v-show="errors.has('insuredCountry')" style="padding: 0" class="alert">close</md-icon>
            </slide-y-down-transition>
            <!-- <slide-y-down-transition>
            <md-icon v-show="!errors.has('country') && touched.country" class="success">done</md-icon>
          </slide-y-down-transition> -->
          </md-field>
        </div>
      </div>
    </div>
    <md-dialog class="modal" :md-active.sync="showModalSMS">
      <md-dialog-title>SMS Terms & Conditions</md-dialog-title>

      <md-dialog-content>
        <ul>
          <li>Messaging frequency may vary.</li>
          <li>Message and data rates may apply.</li>
          <li>You can opt out any time by texting STOP.</li>
          <li>
            For assistance, text HELP or visit our website at
            <a href="https://www.globechek.com" target="_blank"><b>globechek.com</b></a>.
          </li>
          <li>
            Visit <a href="https://globechek.com/tos.html#privacy" target="_blank"><b>Privacy Policy</b></a> and
            <a href="https://globechek.com/tos.html#tos" target="_blank"><b>Terms of Service</b></a>.
          </li>
        </ul>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="closeSMSModal">CONFIRM</md-button>
      </md-dialog-actions>
    </md-dialog>

    <!-- END  -->
  </div>
</template>
<script>
import { IconCheckbox } from "@/components"
import { SlideYDownTransition } from "vue2-transitions"
import $ from "jquery"
import { mapGetters, mapActions } from "vuex"
export default {
  components: {
    IconCheckbox,
    SlideYDownTransition
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      countrySwitch: true,
      firstName: "",
      lastName: "",
      email: "",
      DOB: "",
      gender: "",
      height: "",
      cellPhone: "",
      allowSMS: "",
      address_L1: "",
      address_L2: "",
      city: "",
      state: "",
      zip: "",
      country: "",
      selectedState: null,
      insuranceId: "",
      insurance: "",
      groupNumber: "",
      referralNumber: "",
      patientRelationshipToInsured: 'Self',
      insuredFirstName: '',
      insuredLastName: '',
      insuredAddress: '',
      insuredCity: '',
      insuredState: '',
      insuredCountry: '',
      insuredZip: '',
      insuredGender: '',
      insuredDOB: '',
      filteredStates: [],
      touched: {
        firstName: false,
        lastName: false,
        email: false,
        DOB: false,
        gender: false,
        height: false,
        cellPhone: false,
        allowSMS: false,
        address_L1: false,
        address_L2: false,
        city: false,
        state: false,
        zip: false,
        country: false,
        insuranceId: false,
        insurance: false,
        groupNumber: false,
        referralNumber: false,
        insuredFirstName: false,
        insuredLastName: false,
        insuredAddress: false,
        insuredCity: false,
        insuredState: false,
        insuredCountry: false,
        insuredZip: false,
        insuredGender: false,
        insuredDOB: false,
      },

      modelValidations: {
        firstName: {
          required: true,
          min: 2
        },

        lastName: {
          required: true,
          min: 2
        },

        email: {
          required: true,
          min: 6,
          regex: "^[a-zA-Z0-9+._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,6}$"
        },

        DOB: {
          required: true
        },

        gender: {
          required: true
        },

        height: {
          required: true,
          min: 4
        },

        cellPhone: {
          required: true,
          min: 12
        },

        allowSMS: {
          required: false
        },

        address_L1: {
          required: false,
          min: 2
        },

        address_L2: {
          required: false,
          min: 2
        },

        city: {
          required: true,
          min: 4
        },

        state: {
          required: true,
          min: 2
        },

        zip: {
          required: true,
          min: 5
        },

        country: {
          required: true,
          min: 5
        }
      },
      currentOrg: localStorage.getItem('currentOrg') ? JSON.parse(localStorage.getItem('currentOrg')) : null,
      bizphoneMask: "+99 (999) 999 - 9999",
      stateFilterKeys: "",
      countryFilterKeys: "",
      states: [],
      countries: [],
      tooltipVisible: false,
      hideTimeout: null,
      showModalSMS: false
    }
  },
  mounted() {
    this.defineLookups()
    setTimeout(() => {
      this.currentOrg = localStorage.getItem('currentOrg') ? JSON.parse(localStorage.getItem('currentOrg')) : null
    }, 15000)
  },
  computed: {
    ...mapGetters(["ptPersonal"])
  },
  watch: {
    firstName() {
      this.touched.firstName = true
    },
    lastName() {
      this.touched.lastName = true
    },
    email() {
      this.touched.email = true
    },
    DOB() {
      this.touched.DOB = true
    },
    gender() {
      this.touched.gender = true
    },
    height() {
      this.touched.height = true
    },
    cellPhone() {
      this.touched.cellPhone = true
    },
    address_L1() {
      this.touched.address_L1 = true
    },
    address_L2() {
      this.touched.address_L2 = true
    },
    city() {
      this.touched.city = true
    },
    state() {
      this.touched.state = true
    },
    zip() {
      this.touched.zip = true
    },
    country() {
      this.touched.country = true
    },
    insuranceId() {
      this.touched.insuranceId = true
    },
    insurance() {
      this.touched.insurance = true
    },
    groupNumber() {
      this.touched.groupNumber = true
    },
    referralNumber() {
      this.touched.referralNumber = true
    },
    patientRelationshipToInsured() {
      this.touched.patientRelationshipToInsured = true
    },
    insuredFirstName() {
      this.touched.insuredFirstName = true
    },
    insuredLastName() {
      this.touched.insuredLastName = true
    },
    insuredAddress() {
      this.touched.insuredAddress = true
    },
    insuredCity() {
      this.touched.insuredCity = true
    },
    insuredState() {
      this.touched.insuredState = true
    },
    insuredCountry() {
      this.touched.insuredCountry = true
    },
    insuredZip() {
      this.touched.insuredZip = true
    },
    insuredGender() {
      this.touched.insuredGender = true
    },
    insuredDOB() {
      this.touched.insuredDOB = true
    },
    allowSMS(val) {
      if (val && (this.touched.allowSMS || !this.isEdit)) {
        this.showModalSMS = true
      }

      this.touched.allowSMS = true
    }
  },
  methods: {
    ...mapActions(["listLookupsByMasterName"]),
    filterStates(searchText) {
      if (!searchText) {
        this.filteredStates = this.states // Show all items if no search text
        return
      }
      this.filteredStates = this.states.filter((item) =>
        item.DisplayValue.toLowerCase().includes(searchText.toLowerCase())
      )
    },
    // Handle selection
    onSelectState(item) {
      this.selectedState = item // Update selected item
    },
    fetchLookupByName(name) {
      return this.listLookupsByMasterName(name)
    },
    async defineLookups() {
      try {
        const [states, countries] = await Promise.all([
          this.fetchLookupByName("States"),
          this.fetchLookupByName("CountryCodes")
        ])
        this.states = states
        this.filteredStates = states
        this.countries = countries
        if (this.countries.length === 1) {
          this.country = this.countries[0].LookupId
        }
        if (this.isEdit) {
          this.fillValues()
        }
      } catch (error) {
        console.error("Error fetching lookups:", error)
      }
    },
    defineGender(gender) {
      if (!gender) return ""
      switch (gender.toLowerCase()) {
        case "male":
          return "Male"
        case "female":
          return "Female"
        default:
          return ""
      }
    },
    stringToLookup(lookupList, string) {
      let lookupItem = lookupList.find((item) => item.LookupId === +string)
      if (lookupItem) {
        return lookupItem.LookupId
      } else {
        return null
      }
    },
    fillValues() {
      this.firstName = this.ptPersonal.firstName
      this.lastName = this.ptPersonal.lastName
      this.email = this.ptPersonal.email
      this.DOB = this.ptPersonal.DOB
      this.gender = this.defineGender(this.ptPersonal.gender)
      this.height = this.ptPersonal.height
      this.cellPhone = this.ptPersonal.cellPhone
      this.allowSMS = this.ptPersonal.allowSMS
      this.address_L1 = this.ptPersonal.address_L1
      this.address_L2 = this.ptPersonal.address_L2
      this.city = this.ptPersonal.city
      this.state = this.stringToLookup(this.states, this.ptPersonal.state)
      this.zip = this.ptPersonal.zip
      this.country = this.stringToLookup(this.countries, this.ptPersonal.country)
      this.insuranceId = this.ptPersonal.insuranceId
      this.insurance = this.ptPersonal.insurance
      this.groupNumber = this.ptPersonal.groupNumber
      this.referralNumber = this.ptPersonal.referralNumber
      this.patientRelationshipToInsured = this.ptPersonal.patientRelationshipToInsured
      this.insuredAddress = this.ptPersonal.insuredAddress
      this.insuredCity = this.ptPersonal.insuredCity
      this.insuredState = this.ptPersonal.insuredState
      this.insuredZip = this.ptPersonal.insuredZip
      this.insuredCountry = this.ptPersonal.insuredCountry
      this.insuredGender = this.defineGender(this.ptPersonal.insuredGender)
      this.insuredDOB = this.ptPersonal.insuredDOB
      this.insuredFirstName = this.ptPersonal.insuredFirstName
      this.insuredLastName = this.ptPersonal.insuredLastName
    },
    storeValues() {
      this.ptPersonal.firstName = this.firstName
      this.ptPersonal.lastName = this.lastName
      this.ptPersonal.email = this.email
      this.ptPersonal.DOB = this.DOB
      this.ptPersonal.gender = this.gender
      this.ptPersonal.height = this.height
      this.ptPersonal.cellPhone = this.cellPhone
      this.ptPersonal.allowSMS = this.allowSMS
      this.ptPersonal.address_L1 = this.address_L1
      this.ptPersonal.address_L2 = this.address_L2
      this.ptPersonal.city = this.city
      this.ptPersonal.state = this.state
      this.ptPersonal.zip = this.zip
      this.ptPersonal.country = this.country
      this.ptPersonal.insuranceId = this.insuranceId
      this.ptPersonal.insurance = this.insurance
      this.ptPersonal.groupNumber = this.groupNumber
      this.ptPersonal.referralNumber = this.referralNumber
      this.ptPersonal.patientRelationshipToInsured = this.patientRelationshipToInsured
      this.ptPersonal.insuredAddress = this.insuredAddress
      this.ptPersonal.insuredCity = this.insuredCity
      this.ptPersonal.insuredState = this.insuredState
      this.ptPersonal.insuredZip = this.insuredZip
      this.ptPersonal.insuredCountry = this.insuredCountry
      this.ptPersonal.insuredGender = this.insuredGender
      this.ptPersonal.insuredDOB = this.insuredDOB
      this.ptPersonal.insuredFirstName = this.insuredFirstName
      this.ptPersonal.insuredLastName = this.insuredLastName
    },

    updateDOB() {
      this.DOB = this.picker.getDate(true)
    },

    getError(fieldName) {
      return this.errors.first(fieldName)
    },
    validate() {
      this.storeValues()
      return this.$validator.validateAll().then((res) => {
        this.$emit("on-validated", res)
        return res
      })
    },

    stateFind(event) {
      console.log(event)
      if (event.key === "Escape") {
        this.stateFilterKeys = ""
      }
      if (event.key === "Enter") {
        // this.reRenderState()
        this.$refs.zipCodeInput.$el.focus()
      }
      if (event.key.length > 1) return
      if (this.stateFilterKeys.length < 2) {
        this.stateFilterKeys += event.key.toUpperCase()
      } else {
        this.stateFilterKeys = event.key.toUpperCase()
      }
      let foundStateIndex = this.states.findIndex((state) => {
        return state.DisplayValue.startsWith(this.stateFilterKeys)
      })
      console.log(foundStateIndex)
      let foundState = this.states[foundStateIndex]
      if (!foundState) {
        this.stateFilterKeys = ""
        return
      }
      console.log(foundState)
      this.state = foundState
      let value = this.states.indexOf(foundStateIndex) * 43
      console.log(value)
      let stateID = $("#" + foundState.LookupId + "-state")
      console.log(stateID)
      let scrollParent = $(stateID).parent().parent()
      $(scrollParent).scrollTop(value)
    },
    countryFind(event) {
      if (event.key === "Enter") {
        this.reRenderCountry()
        this.reRenderBizphone(true)
      }
      if (event.key === "Escape") {
        this.countryFilterKeys = ""
      }
      if (event.key === "Backspace") {
        this.countryFilterKeys = this.countryFilterKeys.substring(0, this.countryFilterKeys.length - 1)
      }
      if (event.key.length > 1) return

      this.countryFilterKeys += event.key

      let foundCountry = this.countries.find((country) => {
        return country.DisplayValue.toLowerCase().startsWith(this.countryFilterKeys.toLowerCase())
      })

      this.country = foundCountry
      let value = this.countries.indexOf(foundCountry) * 43
      let countryID = $("#" + foundCountry)
      let scrollParent = $(countryID).parent().parent()

      $(scrollParent).scrollTop(value)
    },
    stateClearFilter() {
      this.stateFilterKeys = ""
    },
    countryClearFilter() {
      this.countryFilterKeys = ""
    },
    focus(type) {
      let el = $("#" + type + "-select")
      el.focus()
    },
    showTooltip() {
      clearTimeout(this.hideTimeout);
      this.tooltipVisible = true;

      this.$nextTick(() => {
        const tooltip = this.$refs.tooltip;
        const wrapper = this.$refs.wrapper;

        if (!tooltip || !wrapper) return;

        const tooltipRect = tooltip.getBoundingClientRect();

        const overflowLeft = tooltipRect.left < 0;

        if (overflowLeft) {
          tooltip.style.left = '0';
          tooltip.style.right = 'auto';
          tooltip.style.transform = 'none';
        }
      });
    },
    hideTooltipWithDelay() {
      this.hideTimeout = setTimeout(() => {
        this.tooltipVisible = false;
      }, 500);
    },
    closeSMSModal() {
      this.showModalSMS = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.lbl1 {
  font-size: 0.6rem;
  color: rgba(0, 0, 0, 0.6);
}

.md-select menu .md-list-item .md-list-item-content {
  min-height: 25px;
}

.md-card-wizard .tab-content {
  padding: 20px, 0px;
}
</style>

<style lang="scss" scoped>
#no-side-padding {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.modify-checkbox {
  .md-checkbox-label {
    padding-left: 5px;
  }
}

.info-icon {
  font-size: 18px;
  cursor: pointer;
  color: #666;
}

.tooltip-wrapper:hover .tooltip-content {
  visibility: visible;
  opacity: 1;
}

.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-content {
  position: absolute;
  top: 125%;
  left: 0;
  background-color: #333;
  color: #fff;
  padding: 1rem;
  border-radius: 0.5rem;
  font-size: 0.75rem;
  z-index: 1000;
  width: 280px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  background-color: #e4e4e5;

}

.tooltip-content ul {
  padding-left: 1.2rem;
  margin: 0;
}

.tooltip-content li {
  margin-bottom: 0.5rem;
  list-style-type: disc;
  color: black;
  font-size: 0.75rem;
}

.modal {
  padding: 12px;
  display: flex;
  flex-direction: column;
}

.md-dialog {
  border-radius: 12px;
  max-width: 500px;
  width: 80%;
}

.md-dialog-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  padding: 12px 8px 0;
}

.md-dialog-content {
  font-size: 0.95rem;
  color: #444;
  line-height: 1.6;
}

.md-dialog-content ul {
  margin-top: 0.5rem;
}

.md-dialog-content li {
  margin-bottom: 0.75rem;
}

.md-dialog-content a {
  color: #0277bd;
  text-decoration: underline;
  transition: color 0.3s;
}

.md-dialog-content a:hover {
  color: #0277bd;
}

.md-dialog-actions {
  display: flex;
  justify-content: flex-end;
}

.md-dialog-actions .md-button {
  background-color: #0277bd;
  color: white;
  border-radius: 4px;
  font-weight: 500;
  text-transform: none;
  transition: background-color 0.3s;
}

.md-dialog-actions .md-button:hover {
  background-color: #0277bd;
}
</style>
